import { z } from "zod/v4";

import { PluginPerformanceSchema } from "../../../schemas/plugin";

export const GetPerformanceResultsRequestBodySchema = z.object({});

export type GetPerformanceResultsRequestBodyType = z.infer<
  typeof GetPerformanceResultsRequestBodySchema
>;

export const GetPerformanceResultsResponseBodySchema = z.object({
  testBalance: z.number(),
  results: PluginPerformanceSchema.array().default([]),
});

export type GetPerformanceResultsResponseBodyType = z.infer<
  typeof GetPerformanceResultsResponseBodySchema
>;
